import { useQuery } from '@tanstack/react-query';
import { CountriesListResponse } from '../interfaces/countriesResponse';
import { AxiosError } from 'axios';
import { IErrorResponse } from '../interfaces/errorResponse';
import { CountryService } from '../services/country';
import { IBaseUseQueryProps } from '../interfaces/baseUseQueryProps';

export const GET_COUNTRY_LIST_QUERY_KEY = 'get-country-list';

export const useGetCountryList = (props?: IBaseUseQueryProps<CountriesListResponse>) => useQuery<CountriesListResponse, AxiosError<IErrorResponse>>({
  queryKey: [GET_COUNTRY_LIST_QUERY_KEY],
  queryFn: () => CountryService.getList(),
  keepPreviousData: true,
  refetchOnWindowFocus: false,
  staleTime: Number.MAX_SAFE_INTEGER,
  ...props
});